import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

const arrow = `    
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;  
  z-index: 5;`;

export const Container = styled.section `
  margin-top: 15px;
  border-top: 1px solid ${Color.greySeparator};
  overflow: hidden;
  position: relative;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    border-top: 1px solid ${ColorDark.greySeparator};
    }
  }
  ${breakpoints.phone} {
    padding-top: 20px;
  }

  h2 {
    text-transform: uppercase;
    color: ${Color.black000};
    ${Font.sansBold};
    font-size: 14px;
    line-height: 24px;
    padding: 15px 0px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color:${ColorDark.textLight};
      }
    }
  }

  .slide-container,
  .slide-preview-next,
  .slide-item {
    background-color: ${Color.greyF5F5F5};
    display: inline-flex;
    justify-content: center;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      background-color:${ColorDark.darkGrey};
      }
  }
  }

  .slide-container {
    padding: 20px 40px;
    padding-left: 48px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      background-color:${ColorDark.darkGrey};
      }
  }
    
    @media (min-width: 724px) and (max-width: 975px) {
      width: 100%;
    }
    @media (max-width: 724px) {
      width: unset !important;
      padding: 20px 10px;
    }
   
  }

  .slide-preview-next {
    .slide:last-child {
      border-right-color: ${Color.greyF5F5F5};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        border-right-color: ${ColorDark.greySeparator};
        }
      }
    }
  }
  .slide-arrow-left,
  .slide-arrow-right {
    background-color: ${Color.white};
    border: 1px solid ${Color.grey};
    ${arrow}

    :hover {
      background-color: ${Color.greySeparator};
      cursor: pointer;
    }

    ${breakpoints.phone} {
      display: none;
    }

    
  }
  .slide-arrow-left {
    left: 50px;
    ${breakpoints.smallDesktop} {
      left: 40px;
    }
    @media (min-width: 976px) and (max-width: 1210px) {
      left: 10px;
    }
   
    svg {
      transform: rotate(90deg);
    }
  }
  .slide-arrow-right {
    right: 50px;

    ${breakpoints.smallDesktop} {
      right: 60px;
    }
    @media (min-width: 976px) and (max-width: 1210px) {
      right: 10px;
    }
    svg {
      transform: rotate(270deg);
    }
  }
`;

export const Slides = styled.div `
  width: 202px;
  border-right: 1px solid ${Color.greySeparator};
  height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 2px;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    border-right:1px solid ${ColorDark.greySeparator};
    }
  }
  ${breakpoints.phone} {
    width: 170px;
  }
  @media (max-width: 1210px) {
     width: 170px;
    }

  ${breakpoints.smallDesktop} {
    width: 190px;
    }

  .hoursRows {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  .head {
    padding-bottom: 8px;
    background-image: linear-gradient(
      to right,
      #555555 10%,
      rgba(255, 255, 255, 0) 0%
    );
    background-position: bottom;
    background-size: 6.5px 2px;
    background-repeat: repeat-x;
  }

  .hoursData {
    display: flex;
    justify-content: space-around;
    color: ${Color.grey};
    justify-content: center;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color:${ColorDark.textLight};
      }
    }
    picture {
      width: 48px;
      height: 48px;
      margin: 0px 15px;
    }
    p {
      height: 100%;
      padding: 0px 15px;

      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      ${Font.sansLight};
      font-size: 20px;
      line-height: 24px;
      color: ${Color.black000};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:${ColorDark.textLight};
        }
      }
      span {
        font-size: 12px;
        line-height: 20px;
      }

      &.degree-size {
        justify-content: space-evenly;
      }
    }

    .hours {
      ${Font.sansRegular};
      color: ${Color.grey};
      font-size: 16px;
      line-height: 20px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:${ColorDark.textLight};
        }
      }
    }
  }

  .conditions {
    margin-top: 10px;
    /* min-height: 40px;
    */

    p {
      ${Font.sansLight};
      font-size: 14px;
      line-height: 20px;
    }
  }
`;